import React from 'react';
import ReactDOM from 'react-dom';
import MstAnalytics from 'mst-analytics';
import '~/assets/styles/common.scss';
import AgreementNew from '../../components/pages/agreementNew2';

ReactDOM.render(
  <AgreementNew />,
  document.getElementById('mst-app'),
);

MstAnalytics.init({
  appKey: 'wg22vlfgaqtfqywspolipkqt',
  // dev: true,
  pageConfig: {},
});

MstAnalytics.separatelyReport('ewt_h5_base_public_agreement2_new_view');



// WEBPACK FOOTER //
// ./src/entries/agreementNew2/agreementNew.jsx